<template>
  <div>
     <header>
          <div class="headerOne">
              <i class="el-icon-arrow-left" @click="goSetting"></i>
              <!-- <img src="../../assets/images/returnOne.png" @click="goSetting"> -->
              <span class="buss">设置</span>
          </div>
      </header>
   
    <div class="allSetting"> 
        <ul>
            <li @click="goPersonage">
                <span>个人信息</span>
                <img src="../../assets/images/goOn.png" alt="">
            </li>
            <li @click="$router.push('/safety')">
                <span>账号与安全</span>
                <img src="../../assets/images/goOn.png" alt="">
            </li>
            <li  @click="$router.push('/aboutMy')"> 
                <span>关于我们</span>
                <img src="../../assets/images/goOn.png" alt="">
            </li>
            <li  @click="openConfirm">
                <span>退出 </span>
                <img src="../../assets/images/goOn.png" alt="">
            </li>
        </ul>
    </div>  
    
  </div>
</template>
<script>
import { MessageBox } from 'mint-ui';
    export default{
        data(){
            return{
                newSrcone:this.$route.query.srcOne,
                msg:"设置页面"
            }
        },
        computed:{
         wsWbsocket(){
           return this.$store.state.wsWbsocket
         }
      },
        methods:{
            goPersonage(){
               this.$router.push({
               path:'/personage',
                query: {
                    srcOne:this.newSrcone
                 }
          })
            },
             openConfirm() {
              MessageBox.confirm('退出后不删除任何历史数据，下次登录依然可以使用本帐号', '提示').then(actions=>{
                        localStorage.clear();
                        reset();
                        this.$router.push({path:"/indexOne"})

                        if (!isDev)
                        {
                            nativeStorageRemove("newObj");
                        }
                        
                    ws.send('{"action":"Logout"}');
                    ws.onmessage = (res)=> 
                     { 
                      var obj = JSON.parse(res.data);
               
               }
                
              });

           },
            goSetting(){
                this.$router.push({path:"/information"})
            }
        }
    }
</script>
<style scoped>
.el-icon-arrow-left{
    font-size: 0.7rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
header{
    height:1.6rem;
    width: 100%;
    border-bottom: 1px solid rgba(0,0,0,0.20);
    position: relative;
}
 .headerOne{
     font-size: 0;  
     }
 .headerOne img{
    display: inline-block;
    margin-top: 0.3rem
 }
  .headerOne img:nth-child(1){
      margin-left: 0.2rem
  }
  .headerOne .buss{
      display: inline-block;
      font-size: 0.55rem;
        position:absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
  }
  .allSetting ul li{
      font-size: 0.55rem;
      color: rgba(0,0,0,0.9);
      height: 1.7rem;
      line-height: 1.7rem;
      border-bottom: 1px solid rgba(0,0,0,0.2);
      padding-left: 0.35rem;
      clear: both;
  }
  /* .allSetting ul li span{
      vertical-align: middle;
   
  } */
   .allSetting ul li img{
       width: 0.35rem;
       height: auto;
       /* vertical-align: middle; */
       float: right;
       margin: 0.58rem 0.5rem 0 0;
   }
</style>



// WEBPACK FOOTER //
// src/components/setting/setting.vue